import { useMutation } from '@apollo/client';
import { ERRORS } from 'constants/notify';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import React, { useMemo } from 'react';
import CommonCompanyForm from 'routes/Company/components/CommonCompanyForm';
import { InputProps } from 'routes/Profile/components/ProfileContent/types';
import { UPDATE_COMPANY } from 'services/graphql/mutations/company';
import { IAddress } from 'types/transaction';
import { defaultNotification } from 'utils';
import * as Yup from 'yup';

import { IStepComponentProps } from './types';

const companyValidation = {
  name: Yup.string().required('Required'),
};

const CompanyWizard: React.FC<IStepComponentProps> = ({ buttonLabel, saveButtonContainerClass, onClickNext }) => {
  const { company } = useCurrentLoggedInUser(); // test nha
  const formFields: InputProps[] = useMemo(
    () => [
      { label: 'Company Name', name: 'name' },
      // {
      //   label: 'Address Line 1',
      //   name: 'address1',
      //   addressSuggestion: true,
      //   addressSuggestionSubFields: {
      //     address1: 'address1',
      //     city: 'city',
      //     zip: 'zip',
      //     state: 'state',
      //   },
      // },
      // { label: 'Address Line 2', name: 'address2' },
      // { label: 'City', name: 'city' },
      // {
      //   label: 'Zip code',
      //   name: 'zip',
      //   sideFields: [
      //     {
      //       label: 'State',
      //       name: 'state',
      //       type: INPUT_TYPE.SELECT,
      //       inputOptions: usStatesSelectOptions,
      //       size: 12,
      //     },
      //   ],
      // },
    ],
    [],
  );

  const [updateCompany, { loading }] = useMutation(UPDATE_COMPANY);
  const companyId = useCurrentLoggedInUser().company?.id;

  const onSubmit = async (v: { name: string } & IAddress) => {
    const { name, ...address } = v;
    try {
      await updateCompany({
        variables: {
          filter: { id: companyId },
          updatedDoc: {
            name,
            address,
          },
        },
      });
      defaultNotification({ success: 'Update company successfully!' });
      onClickNext?.();
    } catch (err) {
      defaultNotification({ failure: ERRORS.DEFAULT_MUTATION_ERROR });
    }
  };

  return (
    // const [updateUser, { loading, error }] = useMutation(UPDATE_USER);
    <div className=''>
      <CommonCompanyForm
        validationObject={companyValidation}
        inputProps={formFields}
        initData={{ name: company?.name }}
        portalButtonClassName={saveButtonContainerClass}
        buttonLabel={buttonLabel}
        loading={loading}
        onSave={onSubmit}
        callbackOnSaveSuccess={onClickNext}
      />
    </div>
  );
};

export default React.memo(CompanyWizard);
